export default __webpack_public_path__ + "static/media/fish.49653e33.png";